import * as React from 'react'
import {
  Datagrid,
  List,
  Edit,
  SimpleForm,
  TextField,
  BooleanField,
  TextInput,
  BooleanInput,
  ShowButton,
  EditButton,
  Pagination,
  Create
} from 'react-admin'

// Simple List component with manual entry - similar to onboarding.js
export const MarketFilterList = props => (
  <List
    {...props}
    title="Market Filters"
    perPage={100}
    sort={{ field: 'id', order: 'ASC' }}
    pagination={<Pagination rowsPerPageOptions={[]} />}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="label" />
      <BooleanField source="enabled" />
      <EditButton />
      <ShowButton label="" />
    </Datagrid>
  </List>
);

// Edit component to modify filter properties
export const MarketFilterEdit = props => (
  <Edit {...props} title="Edit Market Filter" undoable={false}>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="label" />
      <BooleanInput source="enabled" defaultValue={true} />
    </SimpleForm>
  </Edit>
);

// Create component for adding new filters manually
export const MarketFilterCreate = props => (
  <Create {...props} title="Add a Market Filter">
    <SimpleForm>
      <TextInput source="id" helperText="Unique identifier (e.g. 'date', 'experience')" />
      <TextInput source="label" helperText="Display name for the filter" />
      <BooleanInput source="enabled" defaultValue={true} />
    </SimpleForm>
  </Create>
);
